import React, { useEffect, useState, useRef} from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid,  GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import ConfirmDialog from '../ConfirmDialog';
import { useSnackbar } from '../SnackBar';
import { useProgressBar } from '../ProgressBar';
export default function PackageView() {
    const navigate = useNavigate()
    const { GetPackageById, ApprovePackageById } = useServiceContext();
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
      const { id,edit} = useParams();
     const didFetch = useRef(false); 
    const [data, setData] = useState(null);
    const [openApproval, setOpenApproval] = useState(false);
    const userType = localStorage.getItem('userType');
      const getData = async () => {
        
          try {
           
               const d= await GetPackageById(id);
             
                setData(d); // Set loading to false once data is fetched
          
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };
    const handleEdit = () => {
        navigate(`/viewpackage/${data.packageId}/true`);
    }
    const handleApprove = async () => {
        setOpenApproval(true);
       
    }
    const handleCloseApproval = () => {
        setOpenApproval(false); // Close the confirmation dialog 
    };

    const handleConfirmApproval = async () => {
        try {
            showProgress(true);
            const d = await ApprovePackageById(data.packageId);
        
            setData(d);
            setOpenApproval(false);
            showSnackbar('Package approved successfully');
            showProgress(false);
           // setUpdateService(s);

        
           // Close the dialog after successful confirmation
            //await setUpdateService(s);
            //navigate(`/editpartnerservice/${Updateservice.id}/false`);
        } catch (error) {
            console.error('Error approving package:', error);
        }
    };

    useEffect(() => {       
        if (!didFetch.current) {
          getData();    
            didFetch.current = true; // Mark the API call as done          
        }
      });

    return (
       <div>  {didFetch.current && <main id="main" className="main">
            <div className="pagetitle">
            <h1>Branch</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/viewpackage">Packages</a></li>
                      
                        
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                
                                <h5 className="card-title">Package Details</h5>
                                
                              
                                <div className="container">
                                  
                                    <div className="row mb-3">
                                        <nav className="navbar navbar-expand-lg navbar-light">
                                            <div className="container-fluid">

                                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                    </ul>{userType==="PARTNER" &&
                                                        <Button className="right-button"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleEdit} >
                                                            Edit
                                                        </Button>}
                                                    {userType === "ADMIN" && !data.isApproved &&
                                                        <Button className="right-button"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleApprove} >
                                                            Approve
                                                        </Button>}
                                                </div>
                                            </div>
                                        </nav>
    <div className="col-md-6">
      <strong>Package Name:</strong> <span className="ms-2">{data.packageName}</span>
    </div>
    <div className="col-md-6">
      <strong>Package Price:</strong> <span className="ms-2">{data.packagePrice}</span>
    </div>
  </div>
  <div className="row mb-3">
    <div className="col-md-6">
      <strong>Description:</strong> <span className="ms-2">{data.description}</span>
    </div>
    <div className="col-md-6">
      <strong>Approved:</strong> <span className="ms-2">{data.isApproved ? 'Yes' : 'No'}</span>
    </div>
  </div>

  {/* Add a line after Package Details */}
  <hr />

  <h6>Services</h6>
  
  {data.services.map((service, index) => (
    <div key={index} className="card mb-3">
      <div className="card-body">
        
        {/* Add margin-top for space above service name */}
        <div className="row mb-3 mt-3">
          <div className="col-md-6">
            <strong>Service Name:</strong> <span className="ms-2" style={{ fontWeight: 'bold' }}>{service.serviceName}</span>
          </div>
          <div className="col-md-6">
            <strong>Quantity:</strong> <span className="ms-2">{service.quantity}</span>
          </div>
        </div>
        
        {service.addedServices.length > 0 && (
          <div className="col-md-12">
            <strong><u>Added Services</u></strong>
            <ul>
              {service.addedServices.map((addedService, idx) => (
                <li key={idx}>{addedService.name}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  ))}
</div>


                                <ConfirmDialog
                                    open={openApproval}
                                    onClose={handleCloseApproval}
                                    onConfirm={handleConfirmApproval}
                                    title="Confirm Approval"
                                    content="Are you sure you want to approve this Package?"
                                />

</div>


                             
                            </div>
                        </div>
                    </div>
            </section>
        </main>}</div>
    );
}
